import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Globe } from "lucide-react";
import { sectors } from "@/data/products";
import Logo from "@/components/Logo";

export default function Footer() {
  return (
    <footer className="bg-[#0D1A12] text-[#EAE6DF] pt-20 pb-10 mt-32 relative overflow-hidden" data-testid="footer">
      <div className="absolute inset-0 holographic opacity-30 blur-3xl pointer-events-none" />
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-16 relative">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-4">
            <div className="mb-6">
              <Logo size={52} dark />
            </div>
            <p className="text-sm opacity-70 leading-relaxed font-light max-w-sm">
              New Delhi's premier multiproduct export house — delivering premium commodities across 11 sectors to 40+ nations
              at the speed of global trade. Certified, compliant and committed.
            </p>

            <div className="mt-8 space-y-3 text-sm opacity-80">
              <div className="flex items-start gap-3">
                <MapPin size={16} className="mt-0.5 text-[#D4AF37] shrink-0" />
                <span>166, Ram Vihar, Delhi · INDIA · Zip 110092</span>
              </div>
              <div className="flex items-center gap-3">
                <Mail size={16} className="text-[#D4AF37]" />
                <a href="mailto:info@aroverseasexports.com" className="hover:text-[#D4AF37]">info@aroverseasexports.com</a>
              </div>
              <div className="flex items-center gap-3">
                <Phone size={16} className="text-[#D4AF37]" />
                <span>+91 98189 88093 · +91 79826 50076 · +91 83838 13893</span>
              </div>
              <div className="flex items-center gap-3">
                <Globe size={16} className="text-[#D4AF37]" />
                <a href="https://www.aroverseasexports.com" className="hover:text-[#D4AF37]">www.aroverseasexports.com</a>
              </div>
            </div>
          </div>

          <div className="md:col-span-5">
            <p className="text-xs uppercase tracking-[0.3em] text-[#D4AF37] mb-6">Export Sectors</p>
            <div className="grid grid-cols-2 gap-x-6 gap-y-3">
              {sectors.map((s) => (
                <Link key={s.slug} to={`/sectors/${s.slug}`} className="text-sm opacity-75 hover:opacity-100 hover:text-[#D4AF37] transition-colors">
                  {s.name}
                </Link>
              ))}
            </div>

            <p className="text-xs uppercase tracking-[0.3em] text-[#D4AF37] mt-10 mb-4">Leadership</p>
            <div className="grid grid-cols-2 gap-4 text-sm opacity-85">
              <div>
                <div className="font-serif text-base">Sandeep Rajat</div>
                <div className="text-[10px] uppercase tracking-[0.25em] opacity-70 mt-1">CEO · Founder</div>
              </div>
              <div>
                <div className="font-serif text-base">Om Prakash</div>
                <div className="text-[10px] uppercase tracking-[0.25em] opacity-70 mt-1">Operations Director</div>
              </div>
            </div>
          </div>

          <div className="md:col-span-3">
            <p className="text-xs uppercase tracking-[0.3em] text-[#D4AF37] mb-6">Navigate</p>
            <ul className="space-y-3 text-sm opacity-80">
              <li><Link to="/" className="hover:text-[#D4AF37]">Home</Link></li>
              <li><Link to="/catalog" className="hover:text-[#D4AF37]">Product Catalog</Link></li>
              <li><Link to="/about" className="hover:text-[#D4AF37]">About Us</Link></li>
              <li><Link to="/contact" className="hover:text-[#D4AF37]">Request a Quote</Link></li>
            </ul>

            <p className="text-xs uppercase tracking-[0.3em] text-[#D4AF37] mt-8 mb-4">Certifications</p>
            <p className="text-xs opacity-70 leading-relaxed">
              APEDA · ISO 22000 · HACCP<br />
              GlobalG.A.P. · EU Organic<br />
              Halal Certified · GI Tagged
            </p>
          </div>
        </div>

        <div className="gold-divider mt-16" />
        <div className="mt-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs opacity-60">
          <p>© {new Date().getFullYear()} AR Overseas Exports Pvt. Ltd. All rights reserved.</p>
          <p className="tracking-[0.2em] uppercase">Pioneering Global Trade · New Delhi, India</p>
        </div>
      </div>
    </footer>
  );
}
